import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
type Project = {
  name: string;
  tag: string;
  description: string;
  image: string;
  gradient: string;
};
const projects: Project[] = [{
  name: 'TL',
  tag: 'Servicios Profesionales',
  description: 'Landing tech bilingüe con hero animado, servicios destacados y CTA para agendar consulta.',
  image: 'https://cdn.magicpatterns.com/uploads/oSMXCEnscXoCyYK2mtT4i1/Landing_2.png',
  gradient: 'linear-gradient(135deg, #5a4579 0%, #8B6BA8 100%)'
}, {
  name: 'Bloom',
  tag: 'Boutique de Moda',
  description: 'Página editorial premium con presentación de rituales, precios y reserva de citas online.',
  image: 'https://cdn.magicpatterns.com/uploads/gai3M1LvMVXYWn6P9GbbMZ/Landing_3.png',
  gradient: 'linear-gradient(135deg, #1F4E5F 0%, #2E7D8B 100%)'
}, {
  name: 'Casa Dulce',
  tag: 'Catering Latino',
  description: 'Landing para catering de bodas y eventos con menú visual y formulario de cotización.',
  image: 'https://cdn.magicpatterns.com/uploads/anzzRGop4q9JptUxw9JGcJ/Landing_4.png',
  gradient: 'linear-gradient(135deg, #1E2A5E 0%, #2E3F8B 100%)'
}, {
  name: 'FitFlow',
  tag: 'Studio de Fitness',
  description: 'Web para studio boutique de yoga y pilates con horarios, planes y reserva de clases.',
  image: 'https://cdn.magicpatterns.com/uploads/g8DjRZEJKLUiawTxtJmtcn/Landing_5.png',
  gradient: 'linear-gradient(135deg, #5a4579 0%, #8B6BA8 100%)'
}, {
  name: 'DJ',
  tag: 'Entretenimiento & Eventos',
  description: 'Link-in-bio premium con stats, booking para eventos y acceso directo a música y prensa.',
  image: 'https://cdn.magicpatterns.com/uploads/v9WsFjitMU1XTFxdv4zLEg/Landing_6.png',
  gradient: 'linear-gradient(135deg, #1F4E5F 0%, #2E7D8B 100%)'
}];
// Duplicate for seamless infinite loop
const loopProjects = [...projects, ...projects];
export function PortfolioSection() {
  const {
    lang
  } = useLanguage();
  return <section id="portfolio" className="portfolio-section" style={{
    background: '#F5F5F7',
    padding: '60px 0',
    overflow: 'hidden'
  }} data-id="element-362">
      <style data-id="element-363">{`
        @media (min-width: 769px) {
          .portfolio-section { padding: 80px 0 !important; }
        }
        @keyframes portfolio-scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .portfolio-track {
          display: flex;
          width: max-content;
          animation: portfolio-scroll 50s linear infinite;
          will-change: transform;
        }
        .portfolio-card {
          flex-shrink: 0;
          width: 75vw;
          max-width: 320px;
          margin-right: 16px;
        }
        @media (min-width: 769px) {
          .portfolio-card {
            width: 340px;
            max-width: 340px;
            margin-right: 24px;
          }
        }
      `}</style>

      {/* Header */}
      <div className="max-w-3xl mx-auto" style={{
      padding: '0 20px',
      marginBottom: '36px'
    }} data-id="element-364">
        <div style={{
        textAlign: 'center'
      }} data-id="element-365">
          <motion.p initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} style={{
          color: '#5a4579',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '2px',
          textTransform: 'uppercase',
          marginBottom: '12px'
        }} data-id="element-366">
            {lang === 'es' ? 'Nuestros proyectos' : 'Our projects'}
          </motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.05
        }} className="text-[26px] md:text-[34px]" style={{
          color: '#2D1B4E',
          fontWeight: 800,
          lineHeight: 1.2,
          marginBottom: '12px'
        }} data-id="element-367">
            {lang === 'es' ? 'Landing pages que ya están ' : 'Landing pages that are already '}
            <span className="italic" style={{
            background: 'linear-gradient(135deg, #5a4579, #8B6BA8)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            color: 'transparent'
          }} data-id="element-368">
              {lang === 'es' ? 'generando clientes' : 'generating clients'}
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} style={{
          color: '#6B7280',
          fontSize: '15px',
          lineHeight: 1.6,
          maxWidth: '520px',
          margin: '0 auto'
        }} data-id="element-369">
            {lang === 'es' ? 'Cada proyecto fue diseñado para convertir visitas en contactos reales.' : 'Each project was designed to convert visits into real contacts.'}
          </motion.p>
        </div>
      </div>

      {/* Carousel */}
      <div style={{
      position: 'relative'
    }} data-id="element-370">
        <div className="portfolio-track" data-id="element-371">
          {loopProjects.map((p, i) => <a key={i} href="https://inkovastudio.com" target="_blank" rel="noopener noreferrer" className="portfolio-card block" aria-label={`${p.name} — ${p.tag}`} style={{
          background: '#FFFFFF',
          border: '1px solid rgba(90,69,121,0.1)',
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 6px 24px rgba(90,69,121,0.08)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease'
        }} onMouseEnter={e => {
          const el = e.currentTarget as HTMLAnchorElement;
          el.style.transform = 'scale(1.02)';
          el.style.boxShadow = '0 12px 32px rgba(90,69,121,0.16)';
        }} onMouseLeave={e => {
          const el = e.currentTarget as HTMLAnchorElement;
          el.style.transform = 'scale(1)';
          el.style.boxShadow = '0 6px 24px rgba(90,69,121,0.08)';
        }} data-id="element-372">
              {/* Banner with gradient + mockup */}
              <div style={{
            background: p.gradient,
            padding: '20px 20px 0',
            height: '180px',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            overflow: 'hidden'
          }} data-id="element-373">
                <img src={p.image} alt="" aria-hidden="true" draggable={false} style={{
              width: '78%',
              maxWidth: '230px',
              display: 'block',
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
              boxShadow: '0 -8px 24px rgba(0,0,0,0.25)',
              objectFit: 'cover',
              objectPosition: 'top center',
              height: '160px'
            }} data-id="element-374" />
              </div>
            </a>)}
        </div>
      </div>
    </section>;
}